import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import App from 'src/App';
import ScrollTop from 'src/hooks/useScrollTop';
import './styles/globals.css';
import * as serviceWorker from 'src/serviceWorker';
import { installSelectedCompanyForbiddenInterceptor } from 'src/utils/selectedCompanyForbidden';

// npm run buildの際にconsole.log()を何もしないメソッドにすり替え
if (process.env.NODE_ENV !== 'development') {
  console.log = () => {};
}

// 画面の初回マウントのリクエストより先に登録する（log_web_issues#367）
installSelectedCompanyForbiddenInterceptor();

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root element #root not found');
}
const root = createRoot(container);
root.render(
  <BrowserRouter>
    <ScrollTop />
    <App />
  </BrowserRouter>
);

serviceWorker.unregister();
